import Select from '@amzn/meridian/select';
import { localizeWithRef } from './localize';

export default localizeWithRef(Select, ['label', 'placeholder', 'prefix', 'suffix']);
